import * as React from "react";
import {connect} from "react-redux";
import LocationalState, {LocationalRoadObject} from "../LocationalState";
import {Locational} from "../../../../integration/representation/feature";
import {Lane, LaneEdit, SidePositionEdit} from "../../contract-features-3/domain";
import * as selectors from "../selectors";
import {
    OpenLaneModal,
    openLaneModal,
    UpdateLanes,
    updateLanes,
    updateSidePosition,
    UpdateSidePosition
} from "../actions";
import {LaneUpdate} from "../../../../integration/representation/lane";
import {
    getSidePositionRelativeToMeteringDirection, getSidePositionsNorwegian,
    reverseSidePositionIfMeteringDirectionAgainst, sidePositionFromDomain, sidePositionNorwegianToDomain
} from "../../../../sidePositionUtilities";
import {getLanesRelativeToMeteringDirection} from "../../../../laneUtilities";
import datafangstHelpers from "../../../../utilities";
import {locationalHasMeteringDirection} from "../../../../meteringDirectionUtilities";
import {getRefLink} from "../../../../locationalUtilities";

interface TagProps {
    feature: LocationalRoadObject,
    locational: Locational,
}

interface DispatchProps {
    doUpdateSidePosition: UpdateSidePosition;
    doUpdateLanes: UpdateLanes;
    doOpenLaneModal: OpenLaneModal;
}

interface StateProps {
    canHaveSidePosition: boolean;
    canHaveLanes: boolean;
    locationalSelectedForLaneModal: Locational;
}


type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        canHaveSidePosition: selectors.featureInDetailsModalCanHaveSidePosition(state),
        canHaveLanes: selectors.featureInDetailsModalCanHaveLanes(state),
        locationalSelectedForLaneModal: selectors.locationalSelectedForLaneModal(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doUpdateSidePosition: updateSidePosition,
    doUpdateLanes: updateLanes,
    doOpenLaneModal: openLaneModal,
});



class Component extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }


    render() {
        const {
            locational,
            feature,
            canHaveSidePosition,
            doUpdateSidePosition,
            canHaveLanes,
            doOpenLaneModal
        } = this.props;

        const lanesRelativeToMeteringDirection = getLanesRelativeToMeteringDirection(locational);
        return (
            <div className="locational-details-road-card">
                {locational.shortRoadSystemReference && <h3 className="locational-details-road-heading">Vegsystemreferanse relativ til metreringsretning: {locational.shortRoadSystemReference}</h3>}
                <h4 className="locational-details-road-heading">Relativ stedfesting i forhold til geometriretning: {getRefLink(locational)}</h4>

                {!locationalHasMeteringDirection(locational) ?
                    <>
                        <p>Denne lenka har ikke metreringsretning. Sideposisjon og felt kan derfor ikke vises.</p>
                    </>
                :
                <>
                    {canHaveSidePosition &&
                        <>
                            <p className="bold">Sideposisjon i forhold til metreringsretning</p>
                            <SidePositionEditor
                                feature={feature}
                                locational={locational}
                                doUpdateSidePosition={doUpdateSidePosition}
                            />
                            <br />
                            <br />
                        </>

                    }

                    {canHaveLanes &&
                        <>
                            <p className="bold">Felt i forhold til metreringsretning</p>
                            <div className="locational-details-filter-button-group">
                                {lanesRelativeToMeteringDirection.map(lane => {
                                    return (
                                        <button key={lane} className="locational-details-filter-button" onClick={() => this.onLaneClick(lane)}>
                                            <span className="locational-details-filter-button-text">{lane}</span>
                                            <div className="locational-details-filter-button-cross"/>
                                        </button>
                                    )
                                })}
                                <button className="button locational-details-filter-button" onClick={() => doOpenLaneModal(locational)}>
                                    <span className="locational-details-filter-button-text">+</span>
                                </button>
                            </div>

                        </>
                    }
                </>
                }
            </div>
        );
    }

    onLaneClick(lane: Lane) {
        const {feature, locational, doUpdateLanes} = this.props;
        const featureId = feature.id;
        const lanes = locational.lanes;
        const indexOfLaneToRemove = lanes.indexOf(lane);
        lanes.splice(indexOfLaneToRemove, 1);
        let lanesAsString;
        if (lanes.length === 0) {
            lanesAsString = null;
        } else {
            lanesAsString = lanes.join("#");
        }
        const laneUpdate: LaneUpdate = new LaneEdit(lanesAsString, featureId, locational.linkId)
        doUpdateLanes([laneUpdate]);
    }
}

interface DropDownEditorProps {
    doUpdateSidePosition: UpdateSidePosition;
    feature: LocationalRoadObject;
    locational: Locational;
}

interface DropDownEditorState {
    options: string[];
}

class SidePositionEditor extends React.Component<DropDownEditorProps, DropDownEditorState> {

    private inputElement: HTMLSelectElement;

    constructor(props: DropDownEditorProps){
        super(props);
        this.state = {options: getSidePositionsNorwegian()}
    }

    render() {

        let {locational} = this.props;
        const sidePositionRelativeToMeteringDirection = getSidePositionRelativeToMeteringDirection(locational);
        let currentValue = sidePositionFromDomain(sidePositionRelativeToMeteringDirection);

        return (
            <span>
                <select value={currentValue}
                        onChange={(e) => this.handleValueChange(e)}
                        ref={(elm) => this.inputElement = elm}
                >
                    <option key={"novalue"} value={null}> </option>
                    {this.state.options.map(option => <option key={option} value={option}>{option}</option>)}
                </select>
            </span>
        )
    }

    componentDidMount(): void {
        this.inputElement.focus();
    }

    handleValueChange = function (event: React.ChangeEvent<HTMLSelectElement>) {
        let {feature, doUpdateSidePosition, locational} = this.props;
        const selectedSidePositionRelativeToMeteringDirection = sidePositionNorwegianToDomain(event.target.value);
        const meteringDirection = locational.meteringDirection;
        const selectedSidePositionRelativeToGeometryDirection = reverseSidePositionIfMeteringDirectionAgainst(
            selectedSidePositionRelativeToMeteringDirection, meteringDirection
        );
        const sidePositionEdit = new SidePositionEdit(
            selectedSidePositionRelativeToGeometryDirection,
            feature.id,
            locational.linkId
        );
        doUpdateSidePosition(sidePositionEdit)
    }
}


export const RoadLocationalDetails = connect(mapStateToProps, mapDispatchToProps)(Component);
